var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { URLs } from "../url";
import { getHeader, getHeader2 } from "../headers";
import { handleUnauthorized } from "../fetchRequest";
var postGenerateQuote = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var newURL, requestOptions, response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newURL = process.env.REACT_APP_HOST_API + URLs.quote;
                requestOptions = {
                    method: "POST",
                    body: JSON.stringify({ data: body }),
                    headers: getHeader(),
                };
                _a.label = 1;
            case 1:
                _a.trys.push([1, 6, , 7]);
                return [4 /*yield*/, fetch(newURL, requestOptions)];
            case 2:
                response = _a.sent();
                if (!!response.ok) return [3 /*break*/, 4];
                handleUnauthorized(response.status);
                return [4 /*yield*/, response.json()];
            case 3: throw _a.sent();
            case 4: return [4 /*yield*/, response.json()];
            case 5: return [2 /*return*/, (_a.sent())];
            case 6:
                error_1 = _a.sent();
                console.error(error_1);
                throw error_1;
            case 7: return [2 /*return*/];
        }
    });
}); };
var getOneGenerateQuote = function (id, fullBody, log) { return __awaiter(void 0, void 0, void 0, function () {
    var newURL, requestOptions, response, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newURL = process.env.REACT_APP_HOST_API +
                    URLs.quote +
                    "/".concat(id, "/").concat(log ? "Logs" : "", "?fullBody=").concat(fullBody ? fullBody : false);
                requestOptions = {
                    method: "GET",
                    headers: getHeader(),
                };
                _a.label = 1;
            case 1:
                _a.trys.push([1, 6, , 7]);
                return [4 /*yield*/, fetch(newURL, requestOptions)];
            case 2:
                response = _a.sent();
                if (!!response.ok) return [3 /*break*/, 4];
                handleUnauthorized(response.status);
                return [4 /*yield*/, response.json()];
            case 3: throw _a.sent();
            case 4: return [4 /*yield*/, response.json()];
            case 5: return [2 /*return*/, (_a.sent())];
            case 6:
                error_2 = _a.sent();
                console.error(error_2);
                throw error_2;
            case 7: return [2 /*return*/];
        }
    });
}); };
var getAllGenerateQuote = function (clientId, statuses, creationDateStart, creationDateEnd, projectIds, branches, enable, page, limit, numberId, fields, search, catalogStatusQuote, profileDocumentsStatus, isLegacy) { return __awaiter(void 0, void 0, void 0, function () {
    var newURL, requestOptions, response, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newURL = process.env.REACT_APP_HOST_API +
                    URLs.quote +
                    "/All?" +
                    (clientId ? "clientId=".concat(clientId) : "") +
                    (statuses ? "&statuses=".concat(statuses) : "") +
                    (creationDateStart ? "&creationDateStart=".concat(creationDateStart) : "") +
                    (creationDateEnd ? "&creationDateEnd=".concat(creationDateEnd) : "") +
                    (projectIds ? "&projectIds=".concat(projectIds) : "") +
                    (branches ? "&branches=".concat(branches) : "") +
                    (numberId ? "&numberId=".concat(numberId) : "") +
                    (fields ? "&fields=".concat(fields) : "") +
                    (search ? "&search=".concat(search) : "") +
                    (catalogStatusQuote ? "&catalogStatusQuote=".concat(catalogStatusQuote) : "") +
                    "&enable=".concat(enable, "&page=").concat(page, "&limit=").concat(limit) +
                    (profileDocumentsStatus
                        ? "&profileDocumentsStatus=".concat(profileDocumentsStatus)
                        : "") +
                    (isLegacy !== undefined ? "&isLegacy=".concat(isLegacy) : "");
                requestOptions = {
                    method: "GET",
                    headers: getHeader(),
                };
                _a.label = 1;
            case 1:
                _a.trys.push([1, 6, , 7]);
                return [4 /*yield*/, fetch(newURL, requestOptions)];
            case 2:
                response = _a.sent();
                if (!!response.ok) return [3 /*break*/, 4];
                handleUnauthorized(response.status);
                return [4 /*yield*/, response.json()];
            case 3: throw _a.sent();
            case 4: return [4 /*yield*/, response.json()];
            case 5: return [2 /*return*/, (_a.sent())];
            case 6:
                error_3 = _a.sent();
                console.error(error_3);
                throw error_3;
            case 7: return [2 /*return*/];
        }
    });
}); };
var downloadGenerateQuoteAPI = function (clientId, enable, page, limit, creationDateStart, creationDateEnd, fields, labels, contentType, statuses, projectIds, branches, numberId, title) { return __awaiter(void 0, void 0, void 0, function () {
    var newURL, requestOptions, responseAPI, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newURL = process.env.REACT_APP_HOST_API +
                    URLs.quote +
                    "/All" +
                    "?clientId=".concat(clientId) +
                    "&enable=".concat(enable, "&page=").concat(page, "&limit=").concat(limit) +
                    (statuses ? "&statuses=".concat(statuses) : "") +
                    (projectIds ? "&projectIds=".concat(projectIds) : "") +
                    (branches ? "&branches=".concat(branches) : "") +
                    (numberId ? "&numberId=".concat(numberId) : "") +
                    (creationDateStart ? "&creationDateStart=".concat(creationDateStart) : "") +
                    (creationDateEnd ? "&creationDateEnd=".concat(creationDateEnd) : "") +
                    (fields ? "&fields=".concat(fields) : "") +
                    (labels ? "&labels=".concat(labels) : "") +
                    (title ? "&title=".concat(encodeURIComponent(title)) : "");
                requestOptions = {
                    method: "GET",
                    headers: getHeader2(contentType),
                };
                _a.label = 1;
            case 1:
                _a.trys.push([1, 6, , 7]);
                return [4 /*yield*/, fetch(newURL, requestOptions)];
            case 2:
                responseAPI = _a.sent();
                if (!!responseAPI.ok) return [3 /*break*/, 4];
                return [4 /*yield*/, responseAPI.blob()];
            case 3: throw _a.sent();
            case 4: return [4 /*yield*/, responseAPI.blob()];
            case 5: return [2 /*return*/, _a.sent()];
            case 6:
                error_4 = _a.sent();
                console.error(error_4);
                throw error_4;
            case 7: return [2 /*return*/];
        }
    });
}); };
var putQuoteAddFieldsAPI = function (quoteId, key, body) { return __awaiter(void 0, void 0, void 0, function () {
    var newURL, requestOptions, response, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newURL = "".concat(process.env.REACT_APP_HOST_API).concat(URLs.quote, "/").concat(quoteId, "/AdditionalFields/").concat(key);
                requestOptions = {
                    method: "PUT",
                    body: JSON.stringify({ data: body }),
                    headers: getHeader(),
                };
                _a.label = 1;
            case 1:
                _a.trys.push([1, 6, , 7]);
                return [4 /*yield*/, fetch(newURL, requestOptions)];
            case 2:
                response = _a.sent();
                if (!!response.ok) return [3 /*break*/, 4];
                handleUnauthorized(response.status);
                return [4 /*yield*/, response.json()];
            case 3: throw _a.sent();
            case 4: return [4 /*yield*/, response.json()];
            case 5: return [2 /*return*/, _a.sent()];
            case 6:
                error_5 = _a.sent();
                console.error(error_5);
                throw error_5;
            case 7: return [2 /*return*/];
        }
    });
}); };
var attachedDocumentStatusUpdate = function (quoteId, documentId, status, body) { return __awaiter(void 0, void 0, void 0, function () {
    var newURL, requestOptions, response, contentLength, error_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newURL = "".concat(process.env.REACT_APP_HOST_API).concat(URLs.quote, "/").concat(quoteId, "/Attachments/").concat(documentId, "/").concat(status);
                requestOptions = {
                    method: "PUT",
                    body: JSON.stringify({ data: body }),
                    headers: getHeader(),
                };
                _a.label = 1;
            case 1:
                _a.trys.push([1, 8, , 9]);
                return [4 /*yield*/, fetch(newURL, requestOptions)];
            case 2:
                response = _a.sent();
                if (!!response.ok) return [3 /*break*/, 4];
                handleUnauthorized(response.status);
                return [4 /*yield*/, response.json()];
            case 3: throw _a.sent();
            case 4:
                contentLength = response.headers.get("content-length");
                if (!(!contentLength || contentLength === "0")) return [3 /*break*/, 5];
                return [2 /*return*/, "Error ".concat(response.status, ": La respuesta no contiene datos.")];
            case 5: return [4 /*yield*/, response.json()];
            case 6: return [2 /*return*/, _a.sent()];
            case 7: return [3 /*break*/, 9];
            case 8:
                error_6 = _a.sent();
                console.error(error_6);
                throw error_6;
            case 9: return [2 /*return*/];
        }
    });
}); };
export { postGenerateQuote, getOneGenerateQuote, getAllGenerateQuote, downloadGenerateQuoteAPI, putQuoteAddFieldsAPI, attachedDocumentStatusUpdate, };
